import api from '../../api/api'
import router from '../../router'
import Vue from 'vue'

const state = {
  all: []
}

// getters
const getters = {}

// actions
const actions = {
  getAllDuties ({ commit }) {
    api.getDuties(duties => {
      commit('setDuties', duties)
    })
  },
  updateDuty (context, duty) {
    return api.updateDuty(duty.id, duty, function (data) {
      context.commit('updateDutyInState', data)
      context.commit('getAllDuties')
      context.commit('getAllTour')
    })
  },
  addDuty (context, duty) {
    return api.addDuty(duty, function (data) {
      context.commit('addDutyToState', data)
      context.commit('getAllDuties')
      context.commit('getAllTour')
      router.push({name: 'duty', params: {id: data.id}})
    })
  },
  deleteDuty (context, duty) {
    return api.deleteDuty(duty, function (data) {
      let index = state.all.findIndex(value => value.id === duty.id)
      state.all.splice(index, 1)
      context.commit('getAllTour')
    })
  },
  sendMail (context, duty) {
    api.sendMail(duty.id, duty, function () {
      context.commit('getAllDuties')
    })
  }
}

const mutations = {
  getAllDuties () {
    this.dispatch('getAllDuties')
  },
  updateDuty (state, options) {
    this.dispatch('updateDuty', options)
  },
  addDuty (state, options) {
    this.dispatch('addDuty', options)
  },
  deleteDuty (state, options) {
    this.dispatch('deleteDuty', options)
  },
  sendMail (state, options) {
    this.dispatch('sendMail', options)
  },
  setDuties (state, duties) {
    state.all = duties
  },
  addDutyToState (state, duty) {
    state.all.push(duty)
  },
  updateDutyInState (state, duty) {
    let item = state.all.find(item => item.id === duty.id)
    let index = state.all.indexOf(item)
    Vue.set(state.all, index, duty)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/duties.js